/**
 * Hand the browser a JSON file. Blob + anchor — the same mechanism the
 * result-zip download in CampaignActivity uses, with the serialisation folded
 * in so every caller writes the same pretty-printed, application/json file.
 */
export function downloadJson(filename, data) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export default downloadJson;
